/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeDto } from '../../models/employee-dto';

export interface GetAllEmployees$Json$Params {
  EmployeeIds?: Array<string>;
  FromDate?: string;
  ToDate?: string;
  FirstName?: string;
  LastName?: string;
  UnitSearchFilter?: string;
  IncludeInactive?: boolean;
  Units?: Array<string>;
}

export function getAllEmployees$Json(http: HttpClient, rootUrl: string, params?: GetAllEmployees$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllEmployees$Json.PATH, 'get');
  if (params) {
    rb.query('EmployeeIds', params.EmployeeIds, {});
    rb.query('FromDate', params.FromDate, {});
    rb.query('ToDate', params.ToDate, {});
    rb.query('FirstName', params.FirstName, {});
    rb.query('LastName', params.LastName, {});
    rb.query('UnitSearchFilter', params.UnitSearchFilter, {});
    rb.query('IncludeInactive', params.IncludeInactive, {});
    rb.query('Units', params.Units, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EmployeeDto>>;
    })
  );
}

getAllEmployees$Json.PATH = '/v1/mitarbeiter/employees';
